export default __webpack_public_path__ + "static/media/notflixThumbnail.6fbfc4f3.png";